import $ from 'jquery';
import util from 'util/Util.js';
import BasePropertyView from 'BasePropertyView.js';
import formatTemplate from 'properties/main/time_value.ejs';
import mobileSyncService from "../../../service/mobile/MobileSyncService";

//PF-9514
import constants from 'Constants';

class MainTimeValueView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change input[type=radio]' : 'setTimeValue',
            'change #timeValueSpecific' : 'setSpecificTime',
            'change input[type=checkbox]' : 'updateCheckbox',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        if(!this.model.get('specific')) {
            this.model.set('specific','',{silent:true});
        }

        if(!this.model.get('is24HourClock')) {
            this.model.set('is24HourClock','false', {silent: true});
        }
        if(!this.model.get('hasSeconds')) {
            this.model.set('hasSeconds', 'false', {silent: true});
        }

        if (util.isTrue( this.model.get('showEmpty')) ) {
            this.model.set('timeValueType', 'Empty', {silent: true});
        }
        if (util.isTrue( this.model.get('showNow')) ) {
            this.model.set('timeValueType', 'Now', {silent: true});
        }

        if (!util.isTrue( this.model.get('showNow')) && !util.isTrue( this.model.get('showEmpty')) ) {
            this.model.set('timeValueType', 'Specific', {silent: true});
        }

        return this;
    }

    syncDesktopMobile(data) {
        mobileSyncService.synchronizeMobileForm(this.model, this.model.get('factoryKey'), data);
    }


    setTimeValue(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        // PF-9514 use default time value
        const defaultDateTime = constants.DATE_TIME_DEFAULT_VALUE;

        this.model.set( 'showEmpty', 'false', {silent:true} );
        this.syncDesktopMobile({key:  'showEmpty', val: 'false' });

        this.model.set( 'showNow', 'false', {silent:true} );
        this.syncDesktopMobile({key: 'showNow', val: 'false' });

        this.model.set( 'specific', '', {silent:true} );
        this.syncDesktopMobile({key: 'specific', val: '' });


        if(propVal === 'Empty') {
            this.resetSpecific();
            this.model.set('specific', defaultDateTime, {silent:true});
            this.syncDesktopMobile({key: 'specific', val:  defaultDateTime });

            this.model.set( 'showEmpty', 'true', {silent:true} );
            this.syncDesktopMobile( {key: 'showEmpty', val:  'true' });

            // PF-9514 reset attribute to avoid print issue
            this.model.set( 'showNow', 'false', {silent:true} );
            this.syncDesktopMobile({key: 'showNow', val: 'false' });


        }
        if(propVal === 'Now') {
            this.model.set('specific',defaultDateTime, {silent:true});
            this.syncDesktopMobile({key: 'specific', val: defaultDateTime });

            this.model.set( 'showNow', 'true', {silent:true} );
            this.syncDesktopMobile({key: 'showNow', val: 'true' });

            // PF-9514 reset attribute to avoid print issue
            this.model.set( 'showEmpty', 'false', {silent:true} );
            this.syncDesktopMobile({key: 'showEmpty', val: 'false' });
        }
        if(propVal === 'Specific') {
            if (this.model.get('specific') === '') {
                this.model.set('specific',defaultDateTime, {silent:true});
                this.syncDesktopMobile({key: 'specific', val: defaultDateTime });
            }

            $('#timeValueSpecific').attr('disabled', false);
        }

        this.model.set( propName, propVal );
        this.syncDesktopMobile({key: propName, val: propVal });
        this.render();
    }

    setSpecificTime(ev) {
        console.log('setSpecificTime event');
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;
        propVal = '1970/01/01 ' + propVal;

        this.model.set('specific', propVal);
        this.syncDesktopMobile({key: 'specific', val: propVal });
    }

    resetSpecific() {
        $('#timeValueSpecific').attr('disabled', true);
        $('#timeValueSpecific').val('');
    }

    updateCheckbox(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal );

        this.syncDesktopMobile({key: propName, val: propVal });
        this.render();
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );

        this.syncDesktopMobile({key: propName, val: propVal });
    }

    render() {
        this.$el.empty();
        //console.log('time value render');
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        if(this.model.get('timeValueType') === 'Specific') {
            $('#timeValueSpecific').timeEntry('enable');
        } else {
            $('#timeValueSpecific').timeEntry('disable');
        }

        $(":radio[value='"+this.model.get('timeValueType')+"']").attr('checked', true);

        let show24Hour = util.isTrue(this.model.get('is24HourClock'));
        let displaySeconds = util.isTrue(this.model.get('hasSeconds'));

        let spinner = require('editor/icons/spinner-timeEntry.png');

        let bIs24HourClock = util.isTrue(this.model.get('is24HourClock'));
        $(`input[name='is24HourClock']`).prop('checked', bIs24HourClock );

        let bHasSeconds = util.isTrue(this.model.get('hasSeconds'));
        $(`input[name='hasSeconds']`).prop('checked', bHasSeconds );

        $('#timeValueSpecific').timeEntry({
            ampmPrefix: ' ',
            spinnerImage: spinner,
            spinnerIncDecOnly: true,
            spinnerSize: [25,24,0],
            show24Hours: show24Hour,
            showSeconds: displaySeconds,
            defaultTime: util.getTime(this.model.get('specific'), {use24Hour: bIs24HourClock, useSeconds: bHasSeconds})
        });

        $(".timeEntry-control").css({"vertical-align": "-8px", "margin-left":"-23px"});

        if (this.model.get('timeValueType') === 'Empty') {
            $('#timeValueSpecific').val('');
        }

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }

        this.delegateEvents();

        return this;
    }

}

export default MainTimeValueView;
